import Mutations from '../../odata/mutations';

export default { ...new Mutations('account'), ...new Mutations('accounts') };
